(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.tp_ua = {}));
})(this, (function (exports) { 'use strict';

    class UserAgent {
        constructor() {
            this.browser = null;
            this.os = '';
            this.ua = (typeof window === 'undefined') ? '' : window.navigator.userAgent;
        }
        getBrowser() {
            if (!this.browser) {
                this.browser = this.parseUA();
            }
            return this.browser;
        }
        parseUA() {
            const lowerCaseUa = this.ua.toLowerCase();
            for (const key of UserAgent.browserList) {
                const result = UserAgent.browserMap[key](lowerCaseUa);
                if (result) {
                    return key;
                }
            }
            return 'other';
        }
        isImgoEc() {
            return /imgoec/i.test(this.ua);
        }
        isImgo() {
            return /imgotv/i.test(this.ua);
        }
        isIntel() {
            return /intelmgtv/.test(this.ua);
        }
        isImgoTest() {
            return /imgo-test/i.test(this.ua);
        }
        isAndroid() {
            return /(android[\w.\s-]{0,9});.+build/i.test(this.ua);
        }
        isMiniProgram() {
            return /MiniProgram/i.test(this.ua);
        }
        isIos() {
            return /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i.test(this.ua);
        }
        isWx() {
            return this.getBrowser() === 'weixin';
        }
        isWeibo() {
            return this.getBrowser() === 'weibo';
        }
        isQQ() {
            return this.getBrowser() === 'qq';
        }
        isPCWeb() {
            const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(this.ua);
            return !isMobile;
        }
    }
    UserAgent.browserList = ['imgo', 'weixin', 'weibo', 'qq'];
    UserAgent.browserMap = {
        imgo(ua) {
            return /imgo/.test(ua);
        },
        weixin(ua) {
            return /micromessenger/.test(ua);
        },
        weibo(ua) {
            return /weibo/.test(ua);
        },
        qq(ua) {
            return /mqq/.test(ua);
        },
    };
    var main = new UserAgent();

    exports.UserAgent = UserAgent;
    exports["default"] = main;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
